import { render, staticRenderFns } from "./MarketingContainer.vue?vue&type=template&id=1bb64b50&scoped=true"
import script from "./MarketingContainer.vue?vue&type=script&lang=js"
export * from "./MarketingContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb64b50",
  null
  
)

export default component.exports